import { Map as ImmutableMap } from 'immutable';
import { createAction as reduxActionsCreator } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';
import { tracker } from 'app-components/utils/core';

export const DIALOG_TYPE = 'BILL_PRESENTMENT_DIALOG';

export interface BillPresentmentProps {
  series: scheduledTransactionsTypes.ScheduledTransactionType;
  initiator?: string;
}

// Dialog Actions
export const doBillPresentment = reduxActionsCreator(
  rootUiActions.createDialog.toString(),
  (series: scheduledTransactionsTypes.ScheduledTransactionType, initiator?: string) => {
    const reconnect = Boolean(series?.presentmentAccountId);
    tracker.track(tracker.events.addBillStart, { initiator: location, flow: reconnect ? 'reconnect' : 'addNew' });

    return rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: `BPS-${series?.id}`,
      props: ImmutableMap({
        series,
        initiator,
      }),
    });
  },
  (_payload, meta) => meta,
);
